module.exports = __webpack_public_path__ + "static/media/u40_premium_contract6.afe7af01.webp";